import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectBoxLayout from 'components/atoms/Modal/SelectBox.Layout';
import { isACtiveSelectBoxModal } from 'modules/actions/selectBox/index';
import ReactHtmlParser from 'react-html-parser';
import { chatList } from 'modules/actions/chat';
import { weBrowser } from 'lib';

const SelectBox = () => {
  const dispatch = useDispatch();
  /*
   * selectBox 쓰레기봉투판매소 외 모달창에 나오는 데이터
   */
  const selectContentOne = useSelector(state => state.selectBox.selectboxModal.contentOne);
  const selectTrashBagStatus = useSelector(state => state.selectBox.selectboxModal.trashBagStatus);

  /*
   *  쓰레기봉투판매소 용도 데이터
   */
  const selectPurpose = ['용도를 선택해주세요', '일반용(흰색)', '불연성(녹색)', '사업계용(주황색)', '음식물', '필증', '폐기물 스티커', '재사용']; 
 const selectTitle = useSelector(state => state.selectBox.selectboxModal.selectTitle);
  const { items, id } = selectContentOne.contentOne;
  const [Selected, setSelected] = useState('');
  const [purpose, setPurpose] = useState('');
  const deviceEnv = useSelector(state => state.deviceEnv);

  const handleSelect = e => {
    setSelected(e.target.value);
  };

  const handleTwoSelect = e => {
    setPurpose(e.target.value);
  };

  const closedispatch = paramSet => {
    dispatch(chatList(paramSet));
    dispatch(
      isACtiveSelectBoxModal({
        selectboxModal: {
          selectStatus: false,
          contentOne: [],
        },
      })
    );
  };

  const onSendMessage = inStr => {
    const paramSet = {
      inType: 'query',
      inStr,
    };
    closedispatch(paramSet);
  };

  const onSend = inStr => {
    
    console.log(inStr);
    const paramSet = {
      inType: 'query',
      inStr,
    };
    closedispatch(paramSet);
  };

  const constentSet = () => {
    return (
      <>
        <div className="select_box_div">
          <select onChange={handleSelect} value={Selected}>
            {items !== undefined &&
              items.map((tempItem, idx) => {
                return (
                  <option value={tempItem.button.value} key={tempItem + '_' + idx}>
                    {ReactHtmlParser(tempItem?.button?.label || '')}
                  </option>
                );
              })}
          </select>

          {/* 
             쓰레기봉투판매소
          */}
          {selectTrashBagStatus.trashBagStatus === true && (
            <select onChange={handleTwoSelect} value={purpose}>
              {selectPurpose.map((arryItem, idx) => {
                return (
                  <option value={arryItem} key={arryItem + '_' + idx}>
                    {ReactHtmlParser(arryItem || '')}
                  </option>
                );
              })}
            </select>
          )}
        </div>

        {/* 
             쓰레기봉투판매소 그 외
          */}
        <div className="search_box_div">
          {selectTrashBagStatus.trashBagStatus === true ? (
            <div className="select_box_search two" onClick={() => onSend(purpose + ' ' + Selected)}>
              검색하기
            </div>
          ) : (
            <div className="select_box_search one" onClick={() => onSendMessage(Selected)}>
              조회하기
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <SelectBoxLayout
      label={selectTitle}
      value={selectTitle}
      styleDef={{  height: weBrowser() ==='ie'? '161px':'auto'}}
      labelIcon={selectTrashBagStatus.trashBagStatus === true ? 'ri-delete-bin-6-line' : 'ri-sun-cloudy-line'}
      viewStatus=""
      onClickEvt={() =>
        dispatch(
          isACtiveSelectBoxModal({
            selectboxModal: {
              selectStatus: false,
              contentOne: [],
            },
          })
        )
      }
      error={null}
      contentSet={constentSet}
    />
  );
};

export default SelectBox;
